//*Libraries imports
import { CreditCard } from "lucide-react";

//*Types Imports
import { CreditCardBrand } from "@/schemas/asaas/creditCard";

interface CardBrandBadgeProps {
  brand: CreditCardBrand | string;
}

export function CardBrandBadge({ brand }: CardBrandBadgeProps) {
  const normalizedBrand = brand.toUpperCase();

  const getBrandConfig = () => {
    switch (normalizedBrand) {
      case "VISA":
        return {
          label: "Visa",
          colors: "bg-[#1A1F71] text-white border-[#1A1F71]",
          icon: (
            <svg viewBox="0 0 24 24" className="size-3 fill-current">
              <path d="M13.9 15.3h2.3l1.4-8.9h-2.3l-1.4 8.9zm7.5-8.9h-2.2c-.7 0-1.2.4-1.5 1.1l-4.3 10.3h2.4l.5-1.3h2.9l.3 1.3h2.1l-1.8-8.9h.1c-.2-.1-.8-2.5-1-2.5zm-1.4 5.7l.9-2.5.5 2.5h-1.4zM2.5 6.4L2.4 7c1.7.4 2.8 1.4 3.7 2.6L4.2 15.3H6.7l3.8-8.9H7.9l-.1.1c-1.2 0-2.3 0-3.3-1l-2-.1zM11.6 6.4l-1.8 8.9h2.3l1.8-8.9h-2.3z" />
            </svg>
          ),
        };
      case "MASTERCARD":
        return {
          label: "Mastercard",
          colors: "bg-[#EB001B] text-white border-[#EB001B]",
          icon: (
            <div className="flex -space-x-1.5">
              <div className="size-2.5 rounded-full bg-[#EB001B] opacity-90" />
              <div className="size-2.5 rounded-full bg-[#F79E1B] opacity-90" />
            </div>
          ),
        };
      case "AMEX":
        return {
          label: "Amex",
          colors: "bg-[#016FD0] text-white border-[#016FD0]",
          icon: (
            <div className="text-[8px] font-black italic tracking-tighter">
              AMEX
            </div>
          ),
        };
      case "ELO":
        return {
          label: "Elo",
          colors: "bg-black text-white border-black",
          icon: (
            <div className="flex items-center gap-0.5">
              <div className="size-1.5 rounded-full bg-[#EF4123]" />
              <div className="size-1.5 rounded-full bg-[#00AEEF]" />
              <div className="size-1.5 rounded-full bg-[#FFCB05]" />
            </div>
          ),
        };
      case "HIPERCARD":
        return {
          label: "Hipercard",
          colors: "bg-[#B3131B] text-white border-[#B3131B]",
          icon: <div className="text-[8px] font-bold italic">Hiper</div>,
        };
      default:
        return {
          label: normalizedBrand,
          colors: "bg-gray-100 text-gray-700 border-gray-200",
          icon: <CreditCard className="size-2.5" />,
        };
    }
  };

  const config = getBrandConfig();

  return (
    <div
      className={`flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[10px] font-bold border shadow-sm transition-all hover:scale-105 ${config.colors}`}
    >
      {config.icon}
      <span className="uppercase tracking-wider">{config.label}</span>
    </div>
  );
}
